import makeThemeable from '../utils/make-themeable.js'

export const SIZES = ['md', 'sm', 'lg', 'mb', 'xl', 'custom']

export default makeThemeable(SIZES, 'size')
